export const LAST_PATH_STORAGE_KEY = 'xceed-pro-last-path';
